import { QuestionHotelPolicyKidsCosleepingPolicy } from "./kids-cosleeping-policy/kids-cosleeping-policy";
import { QuestionHotelPolicyKidsPolicy } from "./kids-policy/kids-policy";

export const QuestionHotelPolicyKidsPolicyRoot = () => {
	return (
		<>
			<QuestionHotelPolicyKidsPolicy />
			<QuestionHotelPolicyKidsCosleepingPolicy />
		</>
	);
};

QuestionHotelPolicyKidsPolicyRoot.displayName = "QuestionHotelPolicyKidsPolicyRoot";
